import { create } from 'zustand';

interface UnreadState {
  countsByArea: Record<string, number>;
  setCounts(counts: Record<string, number>): void;
  markAreaRead(areaId: string): void;
  incrementArea(areaId: string): void;
  reset(): void;
}

export const useUnreadStore = create<UnreadState>((set) => ({
  countsByArea: {},

  setCounts: (counts) => set({ countsByArea: counts }),

  markAreaRead: (areaId) =>
    set((s) => {
      // Skip update if already 0 — avoids creating a new object reference
      // which would trigger unnecessary re-renders in all subscribers
      if ((s.countsByArea[areaId] ?? 0) === 0) return s;
      return { countsByArea: { ...s.countsByArea, [areaId]: 0 } };
    }),

  incrementArea: (areaId) =>
    set((s) => ({
      countsByArea: {
        ...s.countsByArea,
        [areaId]: (s.countsByArea[areaId] ?? 0) + 1,
      },
    })),

  reset: () => set({ countsByArea: {} }),
}));
